var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9.5a2 2 0 100-4 2 2 0 000 4zm0-6a4.002 4.002 0 013.874 3H22a1 1 0 110 2h-9.126a4.002 4.002 0 01-7.75-.008A1.01 1.01 0 015 8.5H2a1 1 0 010-2h3c.042 0 .083.003.124.008A4.002 4.002 0 019 3.5zm6 15a2 2 0 100-4 2 2 0 000 4zm-13-3h9.126a4.002 4.002 0 017.75.008c.04-.005.082-.008.124-.008h3a1 1 0 110 2h-3c-.042 0-.083-.003-.124-.008a4.002 4.002 0 01-7.75.008H2a1 1 0 110-2z",
    fill: "#fff"
  })));
};
export default SvgSettings;